import _ from "lodash";
import { NO_FOUND } from "shared/product_tabs/tab_parts/data/BomLineItemStatus";

export const valid_buy_options = ["buy", "buy_stock"];

export const getSelectedPS = (bom_line_item, selected_board_qty) => {
  if (!isValidBomLineItem(bom_line_item, selected_board_qty)) return null;
  if (
    hasValidPartSupplierSelections(
      bom_line_item.selected_part,
      selected_board_qty
    )
  )
    return "multiple";
  return `${bom_line_item.selected_part.id}-${bom_line_item.selected_part.selected_part_supplier[selected_board_qty].id}`;
};

export const isValidBomLineItem = (bom_line_item, selected_board_qty) => {
  return (
    hasBomLineItemQuoteFinished(bom_line_item) &&
    isValidSelectedPart(
      bom_line_item.status[selected_board_qty],
      bom_line_item.selected_part
    ) &&
    ((hasValidSelectedPartSupplier(
      bom_line_item.selected_part,
      selected_board_qty
    ) &&
      hasValidSelectedPriceBreak(
        bom_line_item.selected_part.selected_part_supplier,
        selected_board_qty
      )) ||
      hasValidPartSupplierSelections(
        bom_line_item.selected_part,
        selected_board_qty
      ))
  );
};

export const hasBomLineItemQuoteFinished = (bom_line_item) => {
  if (!bom_line_item) return false;
  const { quote_status } = bom_line_item;
  return (
    quote_status == "processed" ||
    quote_status == "unquotable" ||
    quote_status == "unprocessable"
  );
};

export const isValidSelectedPart = (status, selected_part) =>
  status && status != NO_FOUND && !_.isEmpty(selected_part);

export const hasValidSelectedPartSupplier = (
  selected_part,
  selected_board_qty
) => {
  if (!selected_part) return false;
  const selected_part_supplier = selected_part.selected_part_supplier;
  return (
    !_.isEmpty(selected_part_supplier) &&
    selected_board_qty in selected_part_supplier &&
    selected_part_supplier[selected_board_qty] !== undefined &&
    selected_part_supplier[selected_board_qty] !== null
  );
};

export const hasValidSelectedPriceBreak = (
  selected_part_supplier,
  board_qty
) => {
  if (!selected_part_supplier || !board_qty) return false;
  return (
    selected_part_supplier[board_qty].selected_pricebreak &&
    board_qty in selected_part_supplier[board_qty].selected_pricebreak &&
    selected_part_supplier[board_qty].selected_pricebreak[board_qty]
  );
};

export const hasValidPartSupplierSelections = (part, board_qty) => {
  if (!part) return false;
  const { ps_selections } = part;
  return (
    ps_selections &&
    board_qty in ps_selections &&
    ps_selections[board_qty] &&
    ps_selections[board_qty].length > 0
  );
};

export const isValidPartSupplier = (part_supplier, board_qty) => {
  if (!part_supplier || !board_qty) return false;
  return (
    part_supplier.selected_pricebreak &&
    board_qty in part_supplier.selected_pricebreak &&
    part_supplier.selected_pricebreak[board_qty]
  );
};

export const calculateBomTotals = (bom_line_items, board_qtys) => {
  let totals = {};
  bom_line_items
    .filter((bli) => {
      const { status, quote_status, selected_part, user_action } = bli;
      return (
        quote_status == "processed" &&
        valid_buy_options.includes(user_action) &&
        !_.isEmpty(status) &&
        !_.isEmpty(selected_part)
      );
    })
    .forEach((bli) => {
      const { status, price_by_qty } = bli;
      board_qtys.forEach((board_qty) => {
        if (!totals[board_qty]) totals[board_qty] = 0.0;
        if (status[board_qty] && status[board_qty] != NO_FOUND) {
          const total_price = price_by_qty[board_qty] || 0;
          totals[board_qty] += total_price;
        }
      });
    });
  return totals;
};

export const filterSubstitutes = (substitutes, selected_board_qty) => {
  if (!substitutes || substitutes.length == 0) return [];
  return substitutes.filter((substitute) => {
    const selected_part_supplier = hasValidSelectedPartSupplier(
      substitute,
      selected_board_qty
    )
      ? substitute.selected_part_supplier[selected_board_qty]
      : null;
    const selected_pricebreak = selected_part_supplier
      ? selected_part_supplier.selected_pricebreak
      : null;
    return (
      selected_part_supplier &&
      selected_pricebreak &&
      !_.isEmpty(selected_pricebreak) &&
      selected_board_qty in selected_pricebreak &&
      selected_pricebreak[selected_board_qty]
    );
  });
};

export const sortBomLineItems = (bom_line_items, selected_board_qty) => {
  return bom_line_items
    .filter(
      (bli) =>
        bli.error_message[selected_board_qty] &&
        bli.error_message[selected_board_qty] != ""
    )
    .concat(
      bom_line_items.filter(
        (bli) =>
          !bli.error_message[selected_board_qty] ||
          bli.error_message[selected_board_qty] == ""
      )
    );
};

export const validateBomForOrder = (args) => {
  const bom_validation = { valid: true, error_message: "" };
  if (!args) return bom_validation;

  const { saved, changed_zip_file } = args;
  if (saved && changed_zip_file) {
    bom_validation.valid = false;
    bom_validation.error_message =
      "You have uploaded a new zip file, please quote again your bom.";
  }
  return bom_validation;
};
